const RESOLVE_FAILED_DELIVERY = "RESOLVE_FAILED_DELIVERY";
const RESOLVE_FAILED_DELIVERY_SUCCESS = "RESOLVE_FAILED_DELIVERY_SUCCESS";
const RESOLVE_FAILED_DELIVERY_FAILURE = "RESOLVE_FAILED_DELIVERY_FAILURE";
const CLEAR_RESOLVE_FAILED_DELIVERY = "CLEAR_RESOLVE_FAILED_DELIVERY";
const ResolveFailedDeliveySymbols = {
  RESOLVE_FAILED_DELIVERY_SUCCESS,
  RESOLVE_FAILED_DELIVERY_FAILURE,
  RESOLVE_FAILED_DELIVERY,
  CLEAR_RESOLVE_FAILED_DELIVERY,
};
export default ResolveFailedDeliveySymbols;
